import "design/communityCss/communityHeader.css";
import CustomBreadCrumbs from "design/common/customBreadCrumbs";
import { useTranslation } from "react-i18next";
const HeaderBackground = (props: any) => {
  const { route } = props;
  const { t } = useTranslation();
  return (
    <div className={"community-container"}>
      <div className={"community-header-image"}>
        <div className={"community-header-image-navi"}>
          <CustomBreadCrumbs routes={route} />
        </div>
      </div>
    </div>
  );
};
export default HeaderBackground;
